import React, { FC } from "react";
import { ExerciseResults } from "@/components";
import { ExerciseResult } from "@/components/Trains/model";
import styles from "./ExerciseResultsModal.module.scss";

type ExerciseResultsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  results: ExerciseResult[];
  exerciseTitle: string;
};

export const ExerciseResultsModal: FC<ExerciseResultsModalProps> = ({
  isOpen,
  onClose,
  results,
  exerciseTitle,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2 className={styles.title}>Результаты упражнения</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className={styles.content}>
          <ExerciseResults results={results} exerciseTitle={exerciseTitle} />
        </div>
      </div>
    </div>
  );
};
